// Admin-only pages. Each is lazy, so its code never loads for anyone who cannot open it.
import React, { Suspense } from "react";
import { Route } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import AdminRoute from "../components/Shared/AdminRoute.jsx";

const DataSync = React.lazy(() => import("../components/DataSync/DataSync.jsx"));

export const ADMIN_PATHS = { dataSync: "/admin/sync" };

const fallback = (
  <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
    <CircularProgress />
  </Box>
);

// The admin <Route> elements, spread into <Routes> by routesConfig.jsx.
export const adminRoutes = () => [
  <Route
    key="data-sync"
    path={ADMIN_PATHS.dataSync}
    element={
      <AdminRoute>
        <Suspense fallback={fallback}>
          <DataSync />
        </Suspense>
      </AdminRoute>
    }
  />,
];
